export const restDocument = {
	data () {
		return {
			doc:{
				filename:'',
				description:'',
				order: 0,
				file:null,
			},
			docs: [],
			allowedExtensions: ['pdf', 'mp4'],
        		maxFileSize: 128 * 1024 * 1024 //128MB
		}
	},
	methods:{
		getDocsPages (page, search= '', sortKey= '', sortOrder= 'asc', size= 10) {
		const backendurl = this.$store.getters.backendurl
		const params = new URLSearchParams({ page, size })
		if (search) params.set('search', search)
		if (sortKey) params.set('sort', sortKey)
		params.set('order', sortOrder)
		
		//caracter final '/' de api retorna todos sin paginación, quitar para paginación
		this.$http.get(`${backendurl}api/v1/documents?${params.toString()}`)
			.then((response) =>{
				this.docs = response.data || []
				this.totalPages = response.headers.totalpages === undefined
					? 0
					: parseInt(response.headers.totalpages, 10)
		})
		.catch((error) =>{
			console.error(error)
			this.message = error.response.data.message
		})
		},
		postDoc () {
			const backendurl = this.$store.getters.backendurl
			const formData = new FormData()
			formData.append('filename', this.doc.filename)
			formData.append('description', this.doc.description)
			formData.append('order', this.doc.order)
			formData.append('file', this.doc.file)
			this.$http.post(`${backendurl}api/v1/documents`, formData)
				.then(() => {
					this.$router.push(`/documentos`)
				})
				.catch((error) => {
					console.error(error)
					if (error.response && error.response.status === 413) {
						this.validationMessage = 'El archivo es demasiado grande.'
					} else {
						this.validationMessage = error.response && error.response.data && error.response.data.message
							? error.response.data.message
							: 'Ocurrió un error inesperado'
					}
				})
		},
		getDoc () {
			const backendurl = this.$store.getters.backendurl
			this.$http.get(`${backendurl}api/v1/documents/${this.$route.params.idDoc}`)
				.then((response) => {
					this.doc = response.data
				})
				.catch((error) => {
					console.error(error)
					this.validationMessage = error.response && error.response.data
						? error.response.data.message
						: 'No es posible encontrar el documento'
				})
		},
		putDoc () {
			const backendurl = this.$store.getters.backendurl
			this.$http.put(`${backendurl}api/v1/documents/${this.$route.params.idDoc}`, this.doc)
				.then(() => {
					this.$router.push('/documentos')
				})
				.catch((error) => {
					console.error(error)
					this.validationMessage = error.response && error.response.data
						? error.response.data.message
						: 'Ocurrió un error inesperado'
				})
		},
		toggleDocVisibility (idDoc) {
			const backendurl = this.$store.getters.backendurl
			return this.$http.put(`${backendurl}api/v1/documents/${idDoc}/visibility`)
		},
		getVisibleDocs () {
			const backendurl = this.$store.getters.backendurl
			return this.$http.get(`${backendurl}api/v1/documents/visible`)
		},
		contentUrl (item) {
			return `${this.$store.getters.backendurl}api/v1/documents/${item.id}/content`
		},
		deleteDoc () {
			const backendurl = this.$store.getters.backendurl
			return this.$http.delete(`${backendurl}api/v1/documents/${this.$route.params.idDoc}`)
				.then(() => {
					this.$router.push('/documentos')
				})
				.catch((error) => {
					console.error(error)
					this.validationMessage = error.response && error.response.data
						? error.response.data.message
						: 'Ocurrió un error inesperado'
				})
		}
	},
}
